import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent } from '../../components/ui/card'
import { Button } from '../../components/ui/button'
import { Skeleton } from '../../components/ui/Skeleton'
import { useProgressPhotos } from '../../hooks/useProgressPhotos'
import { PhotoUploadForm } from './components/PhotoUploadForm'
import { PhotoGallery } from './components/PhotoGallery'

export function PhotosTab() {
  const { t } = useTranslation()
  const { photos, loading, error, uploading, uploadPhoto, deletePhoto, refetch } = useProgressPhotos()

  if (loading && photos.length === 0) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-48 w-full" />
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          <Skeleton className="aspect-square w-full" />
          <Skeleton className="aspect-square w-full" />
          <Skeleton className="aspect-square w-full" />
        </div>
      </div>
    )
  }

  if (error && photos.length === 0) {
    return (
      <Card className="border-red-500/50">
        <CardContent className="text-center py-8">
          <p className="text-red-500 mb-4">{t('phoenixTracker.error')}</p>
          <Button onClick={refetch} variant="outline">{t('phoenixTracker.retry')}</Button>
        </CardContent>
      </Card>
    )
  }

  return (
    <div className="space-y-4">
      <Card>
        <CardContent className="p-4">
          <PhotoUploadForm onSubmit={uploadPhoto} uploading={uploading} />
        </CardContent>
      </Card>
      {error && (
        <p className="text-sm text-red-500 text-center">{error}</p>
      )}
      <PhotoGallery photos={photos} onDelete={deletePhoto} />
    </div>
  )
}
